import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Buildings, Lock, Warning } from '@phosphor-icons/react';

const ForceChangePasswordPage = () => {
  const { axiosInstance, logout, user } = useAuth();
  const navigate = useNavigate();
  
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      await axiosInstance.post('/api/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      // Redirect to dashboard after successful change
      navigate('/');
      window.location.reload(); // Refresh to update user state
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
      <div className="w-full max-w-md bg-white border border-zinc-200 p-8">
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-amber-100">
              <Warning size={24} className="text-amber-600" />
            </div>
            <div>
              <h1 className="font-heading text-xl font-bold text-zinc-900">
                Cambio de Contraseña Requerido
              </h1>
              <p className="text-sm text-zinc-500">
                Por seguridad, debes cambiar tu contraseña
              </p>
            </div>
          </div>
          <div className="p-3 bg-amber-50 border border-amber-200 text-sm text-amber-800">
            El administrador ha solicitado que cambies tu contraseña antes de continuar.
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="alert-error text-sm" data-testid="force-change-error">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="currentPassword" className="form-label">
              Contraseña Actual
            </label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                id="currentPassword"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="form-input pl-10"
                placeholder="Tu contraseña actual"
                required
                data-testid="current-password-input"
              />
            </div>
          </div>

          <div>
            <label htmlFor="newPassword" className="form-label">
              Nueva Contraseña
            </label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="form-input pl-10"
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                data-testid="new-password-input"
              />
            </div>
          </div>

          <div>
            <label htmlFor="confirmPassword" className="form-label">
              Confirmar Nueva Contraseña
            </label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-input pl-10"
                placeholder="Repite la nueva contraseña"
                required
                data-testid="confirm-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="change-password-submit-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Actualizando...
              </>
            ) : (
              'Cambiar Contraseña'
            )}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={handleLogout}
            className="text-sm text-zinc-500 hover:text-zinc-700"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForceChangePasswordPage;
